var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Gallery',{attrs:{"images":[
    require('@/assets/img/IMG_9710-1200w.jpg'),
    require('@/assets/img/IMG_5082-1200w.jpg'),
    require('@/assets/img/IMG_0404-1200w.jpg') ]}})}
var staticRenderFns = []

export { render, staticRenderFns }